import React from "react";
import { CompanyAccountBalanceContainer } from "../../containers";

const CompanyAccountBalance = (props) => {
  return <CompanyAccountBalanceContainer {...props} />;
};

export default CompanyAccountBalance;
